import { atom } from 'jotai';
import {
  IPlanOverviewDetail,
  ISubjectSubscription,
} from '@models/interfaces/user.interface';
import moment from 'moment/moment';
import { PropsType } from 'geniebook-ui/dist/components/Snackbar';
import { DetailUser } from '@models/types/users.type';

// atom
export const subscriptionInvoiceIdAtom = atom<number | null>(null);
export const subscriptionsAtom = atom<ISubjectSubscription[]>([]);
export const selectedSubjectIdAtom = atom<number | null>(null);
export const planDetailAtom = atom<IPlanOverviewDetail | null>(null);
export const planDetailRecommendedAtom = atom<IPlanOverviewDetail | null>(null);
export const userDetailAtom = atom<DetailUser | null>(null);
export const errorAtom = atom<string | PropsType>('');
export const successAtom = atom<string | PropsType>('');

// helper
export function isExpired(subs: ISubjectSubscription) {
  if (!subs.expiry_date) {
    return false;
  }

  const now = moment();
  // time of server is in sgt (utc +8). don't forget to add +8 to the expiry date data
  const expiryDate = moment(subs.expiry_date + '+08:00');

  return expiryDate.isBefore(now);
}

// derived atom
export const subjectSubscriptionAtom = atom(get => {
  const subscriptions = get(subscriptionsAtom);
  const selectedId = get(selectedSubjectIdAtom);

  if (selectedId === null) {
    return null;
  }

  const searched = subscriptions.find(item => item.subject_id == selectedId);

  return searched ?? null;
});

export const isExpiredAtom = atom(get => {
  const subjectSubscription = get(subjectSubscriptionAtom);
  if (!subjectSubscription) {
    return false;
  }

  return isExpired(subjectSubscription);
});
